<template>
  <div class="wrapper">
    <div class="layout"  @mousemove="handleMouseMove" v-if="!isMobile">
      <img class="bg" :src="`${$cdn}images/bg.jpg`" alt="">
      <video class="bg" :src="`${$cdn}video/bg_video.mp4`" muted autoplay loop></video>
      <bg :moveX='moveX'/>
      <router-view/>
    </div>

    <div class="mobileLayout" v-if="isMobile">
      <img class="bg" :src="`${$cdn}images/mobile/default_bg.png`" alt="">
      
      <router-view/>
    </div>
  </div>
</template>

<script>
import bg from '@/components/bg'
import browser from '@/utils/browser.js'

// import bg from '@/components/background'

function fixIE(event) {
  if(!event){  // 兼容IE浏览器
          event = window.event;
          event.target = event.srcElement;
          event.layerX = event.offsetX;
          event.layerY = event.offsetY;
      }
      event.mx = event.pageX || event.clientX + document.body.scrollLeft;
      // 计算鼠标指针的x轴距离
      event.my = event.pageY || event.clientY + document.body.scrollTop;
      // 计算鼠标指针的y轴距离
      return event;  // 返回标准化的事件对象
  
}
export default {
  mounted(){
  },
  components:{
    bg
  },
  data(){
    return{
      moveX:0,
      isMobile: browser.mobile
    }
  },
  methods:{
    handleMouseMove(e){
      let event = fixIE(e)
      this.moveX =event.mx * 0.04
    }
  }
}
</script>


<style lang="less" scoped>
.wrapper {
  width: 100%;
  height: 100%;
}
.mobileLayout {
  width: 100vw;
  height: 100vh;
  position: fixed;
  left: 0;
  bottom: 0;
  z-index:1;
  .bg {
    width: 100%;
    height: 100%;
  }
  
}
.layout{
  width: 100%;
  height: 100%;
  .bg{
    width: 100%;
    top: 50%;
    left: 50%;
    transform: translate(-50%,-50%);
    z-index: 0;
    position: fixed;
    user-select: none;
  }
}
</style>